import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ILinkProps } from 'modules/core/types';

export const NavigationLink: FC<ILinkProps> = ({ isExternal, path, children }) =>
  isExternal ? <a href={path}>{children}</a> : <Link to={path}>{children}</Link>;
